import { Component, Input } from '@angular/core'
import { NgSwitch, NgSwitchCase } from '@angular/common'

@Component({
  selector: 'app-tax-note',
  templateUrl: './tax-note.component.html',
  styleUrl: './tax-note.component.sass',
  imports: [
    NgSwitch,
    NgSwitchCase,
  ],
})
export class TaxNoteComponent {
  @Input() type!: 'brutto' | 'netto' | 'neutral'
}
